import { FormHelperText } from "@mui/material";
import React from "react";

export const ErrorMessage = ({ error, children }) => (
  <FormHelperText className="Wl-form-error-message" error={error}>
    {children}
  </FormHelperText>
);
